import { putDisplayInQueue } from 'actions'

export const addDisplayToDash = async (payload) => {
  const req = await putDisplayInQueue(payload)
  return { type: 'ADD_DASH_DISPLAY_SUCCESS', data: req.queue }
}
